import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

const LightPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#fffbeb',
      100: '#fef3c7',
      200: '#fde68a',
      300: '#fcd34d',
      400: '#fbbf24',
      500: '#ff8c00',
      600: '#d97706',
      700: '#b45309',
      800: '#92400e',
      900: '#78350f',
      950: '#451a03',
    },
    colorScheme: {
      light: {
        primary: {
          color: '#ff8c00',
          inverseColor: '#ffffff',
          hoverColor: '#D97706',
          activeColor: '#B45309',
        },
      },
    },
    focusRing: {
      width: '0.1rem',
      style: 'solid',
      color: '#9f0840',
      offset: '0px',
      shadow: '0 0 0 0.1rem #9f0840',
    },
    font: {
      family: "'Open Sans', sans-serif",
    },
    borderRadius: {
      none: '0px',
      small: '4px',
      medium: '6px',
      large: '8px',
    },
  },
});

export default LightPreset;
